export default "__VITE_ASSET__adadfb87__"